// 口コミの展開

export function workReviewExpand() {
  const wrapper = document.querySelectorAll<HTMLElement>('.js-works-reviews-wrapper')
  if (wrapper.length === 0) return

  wrapper.forEach((el) => {
    const button = el.querySelector<HTMLElement>('.js-works-review-toggle-more')
    const message = el.querySelector<HTMLElement>('.js-works-review-message')
    const answer = el.querySelector<HTMLElement>('.js-works-review-showing')

    if (button !== null) {
      button.addEventListener('click', (e) => {
        const target = e.currentTarget as HTMLElement

        if (message !== null) {
          message.classList.remove('p-works-review-message-ellipsis')
        }
        if (answer !== null) {
          answer.style.display = 'block'
        }
        target.remove()
      })
    }
  })
}
